import React from 'react';
import { array, bool, func, number, object, shape, string } from 'prop-types';

import CompensationSummaryCard from '../CompensationSummaryCard/CompensationSummaryCard';
import RangeChart from 'ps-components/RangeChartEnhanced/RangeChartEnhanced';
import { numberWithCommas, roundValue } from 'ps-components/lib/formatters';
import './MarketRange.scss';
import { DISPLAY_IN_TYPE } from '../../../lib/displayIn';

class MarketRange extends React.Component {
  static propTypes = {
    checked: bool,
    data: shape({
      '25th': number,
      '50th': number,
      '75th': number,
      scatterData: array,
      scale: object
    }),
    id: string,
    onToggle: func,
    isConfigVisible: bool,
    animate: bool,
    displayIn: string,
    monetaryRounding: number
  };

  shouldComponentUpdate(nextProps) {
    const { checked, data, isConfigVisible } = this.props;
    const isInConfigMode = isConfigVisible !== nextProps.isConfigVisible;
    const didCheckedStatusChange = checked !== nextProps.checked;

    let didDataChange = false;
    if (data && nextProps.data) {
      didDataChange =
        data['25th'] !== nextProps.data['25th'] ||
        data['50th'] !== nextProps.data['50th'] ||
        data['75th'] !== nextProps.data['75th'];
    }

    return didCheckedStatusChange || didDataChange || isInConfigMode;
  }

  currencyFormatter = value => {
    const { displayIn, monetaryRounding } = this.props;
    if (!value) return value;
    if (displayIn === DISPLAY_IN_TYPE.HOURLY) return roundValue(value / 2080, monetaryRounding);
    if (displayIn === DISPLAY_IN_TYPE.THOUSANDS) return roundValue(value / 1000, monetaryRounding);
    return roundValue(value, monetaryRounding);
  };

  tooltipFormatter = (point, position) => {
    const { checked } = this.props;
    // This is a hack to override the range charts default left calculation.
    if (checked) {
      return `
        <div class="d3Tooltip--content d3Tooltip--flag${position}" style="width: 155px">
            <span class="d3Tooltip--heading">
              ${point.employeeName ? point.employeeName : ''}
            </span>
            <div class="div__container--details">
              <span class="d3Tooltip--detail">
                <span class="d3Tooltip--label">Employee Id</span>
                <span class="d3Tooltip--value">${point.employeeNumber}</span>
              </span>
              <span class="d3Tooltip--detail">
                <span class="d3Tooltip--label">${
                  point.employeeAnnualOrHourly === 'Hourly' ? 'Hourly Rate' : 'Base Salary'
                }</span>
                <span class="d3Tooltip--value">${this.currencyFormatter(point.y)}</span>
              </span>
            </div>
        </div>
      `;
    } else {
      return `
        <div class="d3Tooltip--content d3Tooltip--content-disabled d3Tooltip--flag${position} d3Tooltip--flag${position}-disabled" style="width: 155px">
            <span class="d3Tooltip--heading">
             ${point.employeeName ? point.employeeName : ''}
            </span>
            <div class="div__container--details">
              <span class="d3Tooltip--detail">
                <span class="d3Tooltip--label">Employee Id</span>
                <span class="d3Tooltip--value">${point.employeeNumber}</span>
              </span>
              <span class="d3Tooltip--detail">
                <span class="d3Tooltip--label">${
                  point.employeeAnnualOrHourly === 'Hourly' ? 'Hourly Rate' : 'Base Salary'
                }</span>
                <span class="d3Tooltip--value">${this.currencyFormatter(point.y)}</span>
              </span>
            </div>
        </div>
      `;
    }
  };

  render() {
    const { checked, data, id, onToggle, isConfigVisible, animate = false } = this.props;
    const hasData = data ? Object.values(data).length > 0 : false;
    const chartColors = checked ? ['#22d6dd', '#a7eff1'] : ['#80807f', '#c0c0bf'];
    const strokeColor = checked ? null : '#4d4d4c';
    const fillColor = checked ? null : '#f5f5f5';

    return (
      <CompensationSummaryCard
        checked={checked}
        hasData={hasData}
        cardTitle="Market Base Range"
        onToggle={onToggle}
        isConfigVisible={isConfigVisible}
      >
        <div className="comp-sum__range-chart-container">
          <div className="comp-sum__range-chart">
            {data ? (
              <RangeChart
                data={data}
                id={id}
                reportMode="print"
                scale={data.scale}
                animate={animate}
                scatterData={data.scatterData}
                tooltipFormatter={this.tooltipFormatter}
                toolTipWidth={155}
                currencyFormatter={this.currencyFormatter}
                colorOverrides={chartColors}
                fill={fillColor}
                stroke={strokeColor}
              />
            ) : null}
          </div>
        </div>
      </CompensationSummaryCard>
    );
  }
}

export default MarketRange;
